// extracted by mini-css-extract-plugin
module.exports = {"heading":"c_WyE","h1":"IAvgZ","h2":"PBH1B","h3":"IAyEQ","heading_element":"mGcEI"};